// Minimal i18n provider with 5 languages
import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

export const LANGUAGES = [
  { code: "it", label: "Italiano", flag: "🇮🇹" },
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "es", label: "Español", flag: "🇪🇸" },
];

const dict = {
  it: {
    app_name: "ProxiMap",
    tagline: "L'economia di prossimità, sulla mappa.",
    search_placeholder: "Cerca attività, città o categoria…",
    near_me: "Vicino a me",
    share_location: "Condividi la tua posizione",
    enable_location: "Attiva la geolocalizzazione",
    enable_location_desc: "Per scoprire le promozioni esclusive nelle tue vicinanze.",
    skip_location: "Continua come ospite",
    login: "Accedi",
    register: "Registrati",
    logout: "Esci",
    favorites: "Preferiti",
    language: "Lingua",
    all: "Tutte",
    categories: "Categorie",
    restaurant: "Ristoranti",
    pizzerie: "Pizzerie",
    cafe: "Caffè",
    shop: "Negozi",
    hotel: "Hotel",
    pharmacy: "Farmacie",
    bb: "B&B",
    monumenti: "Monumenti",
    musei: "Musei",
    spiagge: "Spiagge",
    archeologia: "Archeologia",
    discoteche: "Discoteche",
    supermercati: "Supermercati",
    bar_pub: "Bar e Pub",
    beni_culturali: "Beni Culturali",
    itinerari: "Itinerari",
    bandiera_blu: "Bandiera Blu",
    bandiera_verde: "Bandiera Verde",
    sea_park: "Parchi Marini",
    bancomat: "Bancomat",
    bar_pasticcerie: "Bar e Pasticcerie",
    ciclo_turismo: "Ciclo Turismo",
    base_discount: "Sconto base",
    proximity_discount: "Bonus prossimità",
    effective_discount: "Sconto attivo",
    within_radius: "Sei nella zona di prossimità",
    outside_radius: "Avvicinati per attivare il bonus",
    distance: "Distanza",
    navigate: "Naviga",
    call: "Chiama",
    website: "Sito web",
    add_favorite: "Aggiungi ai preferiti",
    remove_favorite: "Rimuovi dai preferiti",
    open_promo: "Vedi promozione",
    no_results: "Nessuna attività trovata",
    sign_in: "Entra",
    sign_in_user: "Login utente",
    sign_in_google: "Accedi con Google",
    sign_in_admin: "Accesso superadmin",
    sign_in_proloco: "Accesso Proloco",
    email: "Email",
    password: "Password",
    name: "Nome",
    pin: "PIN alfanumerico",
    submit: "Conferma",
    superadmin_panel: "Dashboard Superadmin",
    proloco_panel: "Pannello Proloco",
    prolocos: "Proloco",
    businesses: "Attività",
    add_proloco: "Aggiungi Proloco",
    add_business: "Aggiungi attività",
    import_xlsx: "Importa XLSX/CSV",
    territory: "Territorio",
    region: "Regione",
    country: "Paese",
    center: "Centro [lat, lng]",
    territory_polygon: "Poligono territoriale",
    contact: "Contatto",
    cap: "CAP",
    comune: "Comune",
    via: "Via e numero civico",
    phone_field: "Telefono",
    email_field: "Email",
    auto_geocode: "Le coordinate verranno generate automaticamente dall'indirizzo",
    geocode_error: "Impossibile geolocalizzare l'indirizzo. Verifica via, CAP e comune.",
    pin_generated: "PIN generato per la Proloco",
    pin_copy: "Copia PIN",
    pin_copied: "PIN copiato negli appunti",
    pin_info: "Conserva questo PIN: la Proloco userà questo codice per accedere al suo pannello e gestire le proprie attività.",
    name_field: "Nome",
    category: "Categoria",
    description: "Descrizione",
    address: "Indirizzo",
    city: "Città",
    phone: "Telefono",
    hours: "Orari",
    image: "Immagine (URL)",
    proximity_radius: "Raggio prossimità (m)",
    promotion_title: "Titolo promozione",
    promotion_description: "Descrizione promozione",
    save: "Salva",
    cancel: "Annulla",
    delete: "Elimina",
    edit: "Modifica",
    regen_pin: "Rigenera PIN",
    welcome_user: "Benvenuto",
    not_authenticated: "Non sei autenticato",
    location_disabled: "Geolocalizzazione disabilitata",
    enable_geolocation_browser: "Abilita la geolocalizzazione nel browser per usare il navigatore.",
    navigator_running: "Navigazione attiva",
    stop_navigation: "Termina navigazione",
    eta: "Tempo stimato",
    discount_active_here: "Promozione attiva qui",
    register_to_save: "Registrati per salvare i preferiti",
    or_continue_with: "oppure",
    list: "Elenco",
    map: "Mappa",
    filters: "Filtri",
    only_promotions: "Solo con promo attive",
    distance_radius: "Raggio (km)",
    home: "Home",
    back: "Indietro",
    pin_login_hint: "Inserisci il PIN alfanumerico fornito dal superadmin",
    no_proloco_yet: "Nessun Proloco registrato",
    inserted: "Inserite",
    skipped: "Saltate",
    upload: "Carica",
    import_tip: "Colonne richieste: name, category, lat, lng. Aliasi (it/en) supportati: nome, categoria, latitudine, longitudine, sconto, bonus, raggio...",
    explore_map: "Esplora la Mappa",
    welcome_desc: "Scopri le attività, i prodotti e le tradizioni del territorio calabrese",
    // Sentieri e Cammini
    trails_and_paths: "Sentieri e Cammini",
    stage: "Tappa",
    stages: "Tappe",
    difficulty: "Difficoltà",
    trail_distance: "Distanza",
    duration: "Durata",
    elevation_gain: "Dislivello",
    loop_trail: "Percorso ad anello",
    gps_track_available: "Tracciato GPS disponibile sulla mappa",
    gps_track_full_available: "Tracciato GPS del cammino completo disponibile",
    view_all_stages: "Vedi tutte le {count} tappe",
    download_gpx: "Scarica GPX",
    follow_trail: "Segui Sentiero",
    follow_cammino: "Segui Cammino",
    open_in_komoot: "Apri in Komoot",
    tourist_discount: "Sconto Turista",
    show_app_discount: "Mostra l'app per ottenere lo sconto",
  },
  en: {
    app_name: "ProxiMap",
    tagline: "Proximity economy, on the map.",
    search_placeholder: "Search businesses, city or category…",
    near_me: "Near me",
    share_location: "Share your location",
    enable_location: "Enable geolocation",
    enable_location_desc: "Discover exclusive promotions near you.",
    skip_location: "Continue as guest",
    login: "Sign in",
    register: "Sign up",
    logout: "Sign out",
    favorites: "Favorites",
    language: "Language",
    all: "All",
    categories: "Categories",
    restaurant: "Restaurants",
    pizzerie: "Pizzerias",
    cafe: "Cafés",
    shop: "Shops",
    hotel: "Hotels",
    pharmacy: "Pharmacies",
    bb: "B&B",
    monumenti: "Monuments",
    musei: "Museums",
    spiagge: "Beaches",
    archeologia: "Archaeology",
    discoteche: "Nightclubs",
    supermercati: "Supermarkets",
    bar_pub: "Bars & Pubs",
    beni_culturali: "Cultural Heritage",
    itinerari: "Itineraries",
    bandiera_blu: "Blue Flag",
    bandiera_verde: "Green Flag",
    sea_park: "Marine Parks",
    bancomat: "ATM",
    bar_pasticcerie: "Ice Cream & Pastry Shops",
    ciclo_turismo: "Cycle Tourism",
    base_discount: "Base discount",
    proximity_discount: "Proximity bonus",
    effective_discount: "Active discount",
    within_radius: "You're inside the proximity zone",
    outside_radius: "Get closer to activate the bonus",
    distance: "Distance",
    navigate: "Navigate",
    call: "Call",
    website: "Website",
    add_favorite: "Save to favorites",
    remove_favorite: "Remove from favorites",
    open_promo: "View promotion",
    no_results: "No businesses found",
    sign_in: "Sign in",
    sign_in_user: "User login",
    sign_in_google: "Continue with Google",
    sign_in_admin: "Superadmin login",
    sign_in_proloco: "Proloco login",
    email: "Email",
    password: "Password",
    name: "Name",
    pin: "Alphanumeric PIN",
    submit: "Submit",
    superadmin_panel: "Superadmin dashboard",
    proloco_panel: "Proloco dashboard",
    prolocos: "Prolocos",
    businesses: "Businesses",
    add_proloco: "Add Proloco",
    add_business: "Add business",
    import_xlsx: "Import XLSX/CSV",
    territory: "Territory",
    region: "Region",
    country: "Country",
    center: "Center [lat, lng]",
    territory_polygon: "Territory polygon",
    contact: "Contact",
    cap: "Postal code",
    comune: "Municipality",
    via: "Street & number",
    phone_field: "Phone",
    email_field: "Email",
    auto_geocode: "Coordinates will be generated automatically from the address",
    geocode_error: "Could not geocode the address. Please check street, postal code and city.",
    pin_generated: "PIN generated for the Proloco",
    pin_copy: "Copy PIN",
    pin_copied: "PIN copied to clipboard",
    pin_info: "Save this PIN: the Proloco will use it to sign in and manage its own businesses.",
    name_field: "Name",
    category: "Category",
    description: "Description",
    address: "Address",
    city: "City",
    phone: "Phone",
    hours: "Hours",
    image: "Image URL",
    proximity_radius: "Proximity radius (m)",
    promotion_title: "Promotion title",
    promotion_description: "Promotion description",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    regen_pin: "Regenerate PIN",
    welcome_user: "Welcome",
    not_authenticated: "Not authenticated",
    location_disabled: "Geolocation disabled",
    enable_geolocation_browser: "Enable browser geolocation to use the navigator.",
    navigator_running: "Navigation running",
    stop_navigation: "Stop navigation",
    eta: "ETA",
    discount_active_here: "Discount active here",
    register_to_save: "Sign up to save favorites",
    or_continue_with: "or",
    list: "List",
    map: "Map",
    filters: "Filters",
    only_promotions: "Active promos only",
    distance_radius: "Radius (km)",
    home: "Home",
    back: "Back",
    pin_login_hint: "Enter the alphanumeric PIN provided by the superadmin",
    no_proloco_yet: "No Proloco yet",
    inserted: "Inserted",
    skipped: "Skipped",
    upload: "Upload",
    import_tip: "Required columns: name, category, lat, lng. Multilingual aliases supported.",
    explore_map: "Explore the Map",
    welcome_desc: "Discover local businesses, products and traditions of Calabria",
    // Trails and Paths
    trails_and_paths: "Trails and Paths",
    stage: "Stage",
    stages: "Stages",
    difficulty: "Difficulty",
    trail_distance: "Distance",
    duration: "Duration",
    elevation_gain: "Elevation gain",
    loop_trail: "Loop trail",
    gps_track_available: "GPS track available on the map",
    gps_track_full_available: "Full trail GPS track available",
    view_all_stages: "View all {count} stages",
    download_gpx: "Download GPX",
    follow_trail: "Follow Trail",
    follow_cammino: "Follow Trail",
    open_in_komoot: "Open in Komoot",
    tourist_discount: "Tourist Discount",
    show_app_discount: "Show the app to get the discount",
  },
  fr: {
    app_name: "ProxiMap",
    tagline: "L'économie de proximité, sur la carte.",
    search_placeholder: "Rechercher activités, ville ou catégorie…",
    near_me: "Près de moi",
    share_location: "Partager ma position",
    enable_location: "Activer la géolocalisation",
    enable_location_desc: "Découvrez les promotions exclusives près de chez vous.",
    skip_location: "Continuer en tant qu'invité",
    login: "Connexion",
    register: "S'inscrire",
    logout: "Déconnexion",
    favorites: "Favoris",
    language: "Langue",
    all: "Toutes",
    categories: "Catégories",
    restaurant: "Restaurants",
    pizzerie: "Pizzerias",
    cafe: "Cafés",
    shop: "Boutiques",
    hotel: "Hôtels",
    pharmacy: "Pharmacies",
    bb: "B&B",
    monumenti: "Monuments",
    musei: "Musées",
    spiagge: "Plages",
    archeologia: "Archéologie",
    discoteche: "Discothèques",
    supermercati: "Supermarchés",
    bar_pub: "Bars et Pubs",
    beni_culturali: "Patrimoine Culturel",
    itinerari: "Itinéraires",
    bandiera_blu: "Pavillon Bleu",
    bandiera_verde: "Pavillon Vert",
    sea_park: "Parcs Marins",
    bancomat: "Distributeur",
    bar_pasticcerie: "Glaciers et Pâtisseries",
    ciclo_turismo: "Cyclotourisme",
    base_discount: "Remise de base",
    proximity_discount: "Bonus proximité",
    effective_discount: "Remise active",
    within_radius: "Vous êtes dans la zone de proximité",
    outside_radius: "Approchez-vous pour activer le bonus",
    distance: "Distance",
    navigate: "Naviguer",
    call: "Appeler",
    website: "Site web",
    add_favorite: "Ajouter aux favoris",
    remove_favorite: "Retirer des favoris",
    open_promo: "Voir la promotion",
    no_results: "Aucune activité trouvée",
    sign_in: "Entrer",
    sign_in_user: "Connexion utilisateur",
    sign_in_google: "Continuer avec Google",
    sign_in_admin: "Connexion superadmin",
    sign_in_proloco: "Connexion Proloco",
    email: "Email",
    password: "Mot de passe",
    name: "Nom",
    pin: "PIN alphanumérique",
    submit: "Valider",
    superadmin_panel: "Tableau de bord superadmin",
    proloco_panel: "Tableau de bord Proloco",
    prolocos: "Prolocos",
    businesses: "Activités",
    add_proloco: "Ajouter un Proloco",
    add_business: "Ajouter une activité",
    import_xlsx: "Importer XLSX/CSV",
    territory: "Territoire",
    region: "Région",
    country: "Pays",
    center: "Centre [lat, lng]",
    territory_polygon: "Polygone territorial",
    contact: "Contact",
    name_field: "Nom",
    category: "Catégorie",
    description: "Description",
    address: "Adresse",
    city: "Ville",
    phone: "Téléphone",
    hours: "Horaires",
    image: "URL image",
    proximity_radius: "Rayon proximité (m)",
    promotion_title: "Titre de la promo",
    promotion_description: "Description de la promo",
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    edit: "Modifier",
    regen_pin: "Régénérer le PIN",
    welcome_user: "Bienvenue",
    not_authenticated: "Non authentifié",
    location_disabled: "Géolocalisation désactivée",
    enable_geolocation_browser: "Activez la géolocalisation du navigateur pour utiliser le navigateur.",
    navigator_running: "Navigation en cours",
    stop_navigation: "Arrêter la navigation",
    eta: "Temps estimé",
    discount_active_here: "Promotion active ici",
    register_to_save: "Inscrivez-vous pour enregistrer les favoris",
    or_continue_with: "ou",
    list: "Liste",
    map: "Carte",
    filters: "Filtres",
    only_promotions: "Promos actives uniquement",
    distance_radius: "Rayon (km)",
    home: "Accueil",
    back: "Retour",
    pin_login_hint: "Entrez le PIN alphanumérique fourni par le superadmin",
    no_proloco_yet: "Aucun Proloco enregistré",
    inserted: "Insérées",
    skipped: "Ignorées",
    upload: "Téléverser",
    import_tip: "Colonnes requises : name, category, lat, lng.",
    explore_map: "Explorer la Carte",
    welcome_desc: "Découvrez les activités, produits et traditions de la Calabre",
    // Sentiers et Chemins
    trails_and_paths: "Sentiers et Chemins",
    stage: "Étape",
    stages: "Étapes",
    difficulty: "Difficulté",
    trail_distance: "Distance",
    duration: "Durée",
    elevation_gain: "Dénivelé",
    loop_trail: "Parcours en boucle",
    gps_track_available: "Tracé GPS disponible sur la carte",
    gps_track_full_available: "Tracé GPS complet du chemin disponible",
    view_all_stages: "Voir les {count} étapes",
    download_gpx: "Télécharger GPX",
    follow_trail: "Suivre le Sentier",
    follow_cammino: "Suivre le Chemin",
    open_in_komoot: "Ouvrir dans Komoot",
    tourist_discount: "Réduction Touriste",
    show_app_discount: "Montrez l'appli pour obtenir la réduction",
  },
  de: {
    app_name: "ProxiMap",
    tagline: "Nahbereichswirtschaft, auf der Karte.",
    search_placeholder: "Geschäfte, Stadt oder Kategorie suchen…",
    near_me: "In meiner Nähe",
    share_location: "Standort teilen",
    enable_location: "Standort aktivieren",
    enable_location_desc: "Entdecke exklusive Angebote in deiner Nähe.",
    skip_location: "Als Gast fortfahren",
    login: "Anmelden",
    register: "Registrieren",
    logout: "Abmelden",
    favorites: "Favoriten",
    language: "Sprache",
    all: "Alle",
    categories: "Kategorien",
    restaurant: "Restaurants",
    pizzerie: "Pizzerien",
    cafe: "Cafés",
    shop: "Geschäfte",
    hotel: "Hotels",
    pharmacy: "Apotheken",
    bb: "B&B",
    monumenti: "Denkmäler",
    musei: "Museen",
    spiagge: "Strände",
    archeologia: "Archäologie",
    discoteche: "Diskotheken",
    supermercati: "Supermärkte",
    bar_pub: "Bars & Kneipen",
    beni_culturali: "Kulturerbe",
    itinerari: "Routen",
    bandiera_blu: "Blaue Flagge",
    bandiera_verde: "Grüne Flagge",
    sea_park: "Meeresparks",
    bancomat: "Geldautomat",
    bar_pasticcerie: "Eisdielen & Konditoreien",
    ciclo_turismo: "Radtourismus",
    base_discount: "Basisrabatt",
    proximity_discount: "Näherungsbonus",
    effective_discount: "Aktiver Rabatt",
    within_radius: "Du bist in der Näherungszone",
    outside_radius: "Komm näher, um den Bonus zu aktivieren",
    distance: "Entfernung",
    navigate: "Navigieren",
    call: "Anrufen",
    website: "Webseite",
    add_favorite: "Zu Favoriten",
    remove_favorite: "Aus Favoriten entfernen",
    open_promo: "Aktion ansehen",
    no_results: "Keine Geschäfte gefunden",
    sign_in: "Einloggen",
    sign_in_user: "Benutzer-Login",
    sign_in_google: "Mit Google fortfahren",
    sign_in_admin: "Superadmin-Login",
    sign_in_proloco: "Proloco-Login",
    email: "E-Mail",
    password: "Passwort",
    name: "Name",
    pin: "Alphanumerischer PIN",
    submit: "Bestätigen",
    superadmin_panel: "Superadmin-Dashboard",
    proloco_panel: "Proloco-Dashboard",
    prolocos: "Prolocos",
    businesses: "Geschäfte",
    add_proloco: "Proloco hinzufügen",
    add_business: "Geschäft hinzufügen",
    import_xlsx: "XLSX/CSV importieren",
    territory: "Gebiet",
    region: "Region",
    country: "Land",
    center: "Zentrum [lat, lng]",
    territory_polygon: "Gebietspolygon",
    contact: "Kontakt",
    name_field: "Name",
    category: "Kategorie",
    description: "Beschreibung",
    address: "Adresse",
    city: "Stadt",
    phone: "Telefon",
    hours: "Öffnungszeiten",
    image: "Bild-URL",
    proximity_radius: "Näherungsradius (m)",
    promotion_title: "Aktionstitel",
    promotion_description: "Aktionsbeschreibung",
    save: "Speichern",
    cancel: "Abbrechen",
    delete: "Löschen",
    edit: "Bearbeiten",
    regen_pin: "PIN neu generieren",
    welcome_user: "Willkommen",
    not_authenticated: "Nicht authentifiziert",
    location_disabled: "Standort deaktiviert",
    enable_geolocation_browser: "Browser-Standort aktivieren, um den Navigator zu nutzen.",
    navigator_running: "Navigation aktiv",
    stop_navigation: "Navigation beenden",
    eta: "Ankunftszeit",
    discount_active_here: "Rabatt aktiv",
    register_to_save: "Registriere dich, um Favoriten zu speichern",
    or_continue_with: "oder",
    list: "Liste",
    map: "Karte",
    filters: "Filter",
    only_promotions: "Nur aktive Aktionen",
    distance_radius: "Radius (km)",
    home: "Startseite",
    back: "Zurück",
    pin_login_hint: "Gib den vom Superadmin bereitgestellten PIN ein",
    no_proloco_yet: "Noch kein Proloco",
    inserted: "Eingefügt",
    skipped: "Übersprungen",
    upload: "Hochladen",
    import_tip: "Pflichtspalten: name, category, lat, lng.",
    explore_map: "Karte Erkunden",
    welcome_desc: "Entdecke lokale Geschäfte, Produkte und Traditionen Kalabriens",
    // Wanderwege und Pfade
    trails_and_paths: "Wanderwege und Pfade",
    stage: "Etappe",
    stages: "Etappen",
    difficulty: "Schwierigkeit",
    trail_distance: "Entfernung",
    duration: "Dauer",
    elevation_gain: "Höhenunterschied",
    loop_trail: "Rundweg",
    gps_track_available: "GPS-Track auf der Karte verfügbar",
    gps_track_full_available: "Vollständiger GPS-Track des Weges verfügbar",
    view_all_stages: "Alle {count} Etappen anzeigen",
    download_gpx: "GPX herunterladen",
    follow_trail: "Wanderweg folgen",
    follow_cammino: "Weg folgen",
    open_in_komoot: "In Komoot öffnen",
    tourist_discount: "Touristenrabatt",
    show_app_discount: "Zeige die App für den Rabatt",
  },
  es: {
    app_name: "ProxiMap",
    tagline: "Economía de proximidad, en el mapa.",
    search_placeholder: "Busca negocios, ciudad o categoría…",
    near_me: "Cerca de mí",
    share_location: "Compartir mi ubicación",
    enable_location: "Activar la geolocalización",
    enable_location_desc: "Descubre promociones exclusivas cerca de ti.",
    skip_location: "Continuar como invitado",
    login: "Entrar",
    register: "Registrarse",
    logout: "Cerrar sesión",
    favorites: "Favoritos",
    language: "Idioma",
    all: "Todas",
    categories: "Categorías",
    restaurant: "Restaurantes",
    pizzerie: "Pizzerías",
    cafe: "Cafeterías",
    shop: "Tiendas",
    hotel: "Hoteles",
    pharmacy: "Farmacias",
    bb: "B&B",
    monumenti: "Monumentos",
    musei: "Museos",
    spiagge: "Playas",
    archeologia: "Arqueología",
    discoteche: "Discotecas",
    supermercati: "Supermercados",
    bar_pub: "Bares y Pubs",
    beni_culturali: "Patrimonio Cultural",
    itinerari: "Itinerarios",
    bandiera_blu: "Bandera Azul",
    bandiera_verde: "Bandera Verde",
    sea_park: "Parques Marinos",
    bancomat: "Cajero",
    bar_pasticcerie: "Heladerías y Pastelerías",
    ciclo_turismo: "Cicloturismo",
    base_discount: "Descuento base",
    proximity_discount: "Bonus proximidad",
    effective_discount: "Descuento activo",
    within_radius: "Estás en la zona de proximidad",
    outside_radius: "Acércate para activar el bonus",
    distance: "Distancia",
    navigate: "Navegar",
    call: "Llamar",
    website: "Sitio web",
    add_favorite: "Añadir a favoritos",
    remove_favorite: "Quitar de favoritos",
    open_promo: "Ver promoción",
    no_results: "No se encontraron negocios",
    sign_in: "Entrar",
    sign_in_user: "Acceso usuario",
    sign_in_google: "Continuar con Google",
    sign_in_admin: "Acceso superadmin",
    sign_in_proloco: "Acceso Proloco",
    email: "Email",
    password: "Contraseña",
    name: "Nombre",
    pin: "PIN alfanumérico",
    submit: "Confirmar",
    superadmin_panel: "Panel Superadmin",
    proloco_panel: "Panel Proloco",
    prolocos: "Prolocos",
    businesses: "Negocios",
    add_proloco: "Añadir Proloco",
    add_business: "Añadir negocio",
    import_xlsx: "Importar XLSX/CSV",
    territory: "Territorio",
    region: "Región",
    country: "País",
    center: "Centro [lat, lng]",
    territory_polygon: "Polígono territorial",
    contact: "Contacto",
    name_field: "Nombre",
    category: "Categoría",
    description: "Descripción",
    address: "Dirección",
    city: "Ciudad",
    phone: "Teléfono",
    hours: "Horario",
    image: "URL imagen",
    proximity_radius: "Radio proximidad (m)",
    promotion_title: "Título de la promo",
    promotion_description: "Descripción de la promo",
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    edit: "Editar",
    regen_pin: "Regenerar PIN",
    welcome_user: "Bienvenido",
    not_authenticated: "No autenticado",
    location_disabled: "Geolocalización desactivada",
    enable_geolocation_browser: "Activa la geolocalización del navegador para usar el navegador.",
    navigator_running: "Navegación activa",
    stop_navigation: "Detener navegación",
    eta: "Tiempo estimado",
    discount_active_here: "Promoción activa aquí",
    register_to_save: "Regístrate para guardar favoritos",
    or_continue_with: "o",
    list: "Lista",
    map: "Mapa",
    filters: "Filtros",
    only_promotions: "Solo promos activas",
    distance_radius: "Radio (km)",
    home: "Inicio",
    back: "Volver",
    pin_login_hint: "Introduce el PIN alfanumérico proporcionado por el superadmin",
    no_proloco_yet: "Aún no hay Proloco",
    inserted: "Insertados",
    skipped: "Omitidos",
    upload: "Subir",
    import_tip: "Columnas requeridas: name, category, lat, lng.",
    explore_map: "Explorar el Mapa",
    welcome_desc: "Descubre los negocios, productos y tradiciones de Calabria",
    // Senderos y Caminos
    trails_and_paths: "Senderos y Caminos",
    stage: "Etapa",
    stages: "Etapas",
    difficulty: "Dificultad",
    trail_distance: "Distancia",
    duration: "Duración",
    elevation_gain: "Desnivel",
    loop_trail: "Ruta circular",
    gps_track_available: "Track GPS disponible en el mapa",
    gps_track_full_available: "Track GPS completo del camino disponible",
    view_all_stages: "Ver las {count} etapas",
    download_gpx: "Descargar GPX",
    follow_trail: "Seguir Sendero",
    follow_cammino: "Seguir Camino",
    open_in_komoot: "Abrir en Komoot",
    tourist_discount: "Descuento Turista",
    show_app_discount: "Muestra la app para obtener el descuento",
  },
};

const I18nContext = createContext({ lang: "it", t: (k) => k, setLang: () => {} });

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const saved = typeof window !== "undefined" ? localStorage.getItem("pm_lang") : null;
    if (saved && dict[saved]) return saved;
    const browser = typeof navigator !== "undefined" ? navigator.language?.slice(0, 2) : "it";
    return dict[browser] ? browser : "it";
  });

  useEffect(() => {
    if (typeof window !== "undefined") localStorage.setItem("pm_lang", lang);
    if (typeof document !== "undefined") document.documentElement.lang = lang;
  }, [lang]);

  const setLang = useCallback((l) => {
    if (dict[l]) setLangState(l);
  }, []);

  const t = useCallback((key) => {
    return (dict[lang] && dict[lang][key]) || dict.en[key] || key;
  }, [lang]);

  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  return useContext(I18nContext);
}
